var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegenerateicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16686_14369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9614 8.49203C14.4567 8.4965 14.0327 8.87243 13.9677 9.3729C13.4869 12.6578 10.4342 14.931 7.14926 14.4503C3.86433 13.9695 1.59111 10.9167 2.0719 7.6318C2.55269 4.34687 5.60543 2.07365 8.89036 2.55444C10.0101 2.71832 11.0608 3.19495 11.9217 3.92952L11.1676 4.68361C10.907 4.94424 10.9071 5.36678 11.1677 5.62735C11.2933 5.75291 11.4638 5.82323 11.6414 5.82273H14.7018C15.0703 5.82273 15.3691 5.52397 15.3691 5.15542V2.09505C15.369 1.7265 15.0702 1.42779 14.7016 1.42786C14.5247 1.42789 14.355 1.49818 14.23 1.62324L13.3411 2.51212C10.0341 -0.41778 4.97806 -0.112103 2.04813 3.19492C-0.881799 6.50193 -0.576059 11.558 2.73093 14.4879C6.03792 17.4178 11.094 17.1121 14.0239 13.8051C15.0553 12.6409 15.725 11.2014 15.951 9.66253C16.0395 9.11161 15.6646 8.59325 15.1136 8.50479C15.0633 8.49669 15.0124 8.49243 14.9614 8.49203Z",
    fill: "#E66100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16686_14369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenerateicon);
export default __webpack_public_path__ + "static/media/regenerate icon.28560cb108d561871be443511d59ee2d.svg";
export { ForwardRef as ReactComponent };